module.exports = __webpack_public_path__ + "static/media/ico-search.c9ae37f0.svg";